<div>
  @if (!loading) {
    <div class="manage-users-headers">
      <div class="page-title">CDFI Leads Quota</div>
      @if (leadsQuota.length > 0) {
        <div class="page-size">
          <app-page-size
            [pageSize]="pageSize"
            [selectId]="'cdfi-leads-quota-logs'"
            (pageSizeChanged)="onPageSizeChange($event)"
          ></app-page-size>
        </div>
      }
    </div>
    <div class="filter-search-section">
      <div class="search-section-wrapper">
        <app-search-input
          [placeholder]="'Search Connection ...'"
          [(searchQuery)]="searchQuery"
          (searchQueryChange)="onSearchQueryChange($event)"
        ></app-search-input>
      </div>
      <div class="add-connection">
        <a
          href="javascript:void(0)"
          class="add-connection-btn"
          (click)="showAddConnectionQuotaPopupHandler()"
        >
          <app-svg-icon
            [iconName]="'add.svg'"
            [height]="'16px'"
            [width]="'16px'"
            [style.fill]="'#fff'"
          ></app-svg-icon>
          <span>Add Connection</span>
        </a>
      </div>
    </div>

    <div class="cdfi-quota-list">
      @for (result of leadsQuota; track $index) {
        <app-connection-quota
          [connectionQuota]="result"
          [sourceTypes]="sourceTypes"
          (deletedConnectionQuota)="removeConnectionQuota(result.connection_id)"
          (updatedSourceQuotaDetails)="reloadLeadsQuota()"
        ></app-connection-quota>
      } @empty {
        <div class="no-results">No quotas found.</div>
      }
    </div>
  } @else {
    <div class="manage-users-headers">
      <div class="page-title">CDFI Leads Quota</div>
    </div>

    <div class="cdfi-quota-list">
      @for (item of [1, 2, 3]; track $index) {
        <div class="quota-item skeleton">
          <div class="item-header">
            <div class="connection-info">
              <div class="skeleton-box heading"></div>
            </div>
            <div class="header-stats">
              <div class="stat">
                <div class="skeleton-box"></div>
              </div>
              <div class="stat">
                <div class="skeleton-box"></div>
              </div>
              <div class="stat">
                <div class="skeleton-box"></div>
              </div>
            </div>
            <div class="expand-arrow">
              <div class="skeleton-box icon"></div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>

@if (!loading && leadsQuota.length > 0) {
  <app-pagination
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [totalItems]="totalCDFILeadsQuotaLogs"
    (pageChanged)="onPageChange($event)"
  ></app-pagination>
}

@if (showAddConnectionQuotaPopup) {
  <app-popup
    [heading]="'Add Connection Quota'"
    [confirmText]="'Add'"
    [cancelText]="'Cancel'"
    (confirmClicked)="createConnectionQuota()"
    (cancelClicked)="showAddConnectionQuotaPopup = false"
  >
    <div class="add-quota-form">
      @if (connectionQuotaError) {
        <div class="error-message">{{ connectionQuotaError }}</div>
      }
      <div class="form-group">
        <label for="connectionSelect">Connection</label>
        <select
          id="connectionSelect"
          [(ngModel)]="newConnectionQuota.connectionId"
          class="quota-input"
        >
          <option [ngValue]="null">Select a connection</option>
          @for (conn of filteredConnections; track $index) {
            <option [ngValue]="conn.connection_id">
              {{ conn.connection_display_name }}
            </option>
          }
        </select>
      </div>
      @for (quota of newConnectionQuota.sourceQuotas; track $index) {
        <div class="source-quota-group">
          <div class="form-group">
            <label [for]="'sourceType' + $index">Source Type</label>
            <select
              [id]="'sourceType' + $index"
              [(ngModel)]="quota.sourceType"
              class="quota-input"
            >
              <option [ngValue]="null">Select a source type</option>
              @for (
                type of getAvailableSourceTypesForDropdown($index);
                track $index
              ) {
                <option [ngValue]="type.source_type">
                  {{ type.source_display_name }}
                </option>
              }
            </select>
          </div>
          <div class="form-group">
            <label [for]="'maxQuota' + $index">Max Quota</label>
            <input
              [id]="'maxQuota' + $index"
              type="number"
              min="0"
              [(ngModel)]="quota.maxQuota"
              class="quota-input"
            />
          </div>
          <div style="float: right">
            <button
              type="button"
              class="remove-source-btn"
              (click)="removeSourceQuotaField($index)"
              [disabled]="newConnectionQuota.sourceQuotas.length === 1"
            >
              <app-svg-icon
                [iconName]="'delete.svg'"
                [height]="'16px'"
                [width]="'16px'"
              ></app-svg-icon>
            </button>
          </div>
        </div>
      }
      <button
        type="button"
        class="add-source-btn"
        (click)="addSourceQuotaField()"
        [disabled]="!canAddMoreSourceTypes()"
      >
        <app-svg-icon
          [iconName]="'add.svg'"
          [height]="'16px'"
          [width]="'16px'"
          [style.fill]="'#334ea5'"
        ></app-svg-icon>
        Add Source
      </button>
    </div>
  </app-popup>
}
